
import {basicTheme} from "./basic.js"

export function autoTheme() {
	return basicTheme()
}

